import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function PaymentError(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "PaymentError", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M33.414 9H7.344A4.345 4.345 0 0 0 3 13.345v14.483c0 2.4 1.945 4.344 4.345 4.344h26.069c2.4 0 4.345-1.945 4.345-4.344V13.345c0-2.4-1.946-4.345-4.345-4.345Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M37.759 13.345H3v4.345h34.759v-4.345Z", fill: theme.vars.palette.primary.light }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M14.587 27.103H7.345a.724.724 0 0 1 0-1.448h7.242a.724.724 0 1 1 0 1.448Zm5.793 0h-2.897a.724.724 0 1 1 0-1.448h2.897a.724.724 0 1 1 0 1.448Zm-2.897-2.896H7.345a.724.724 0 0 1 0-1.449h10.138a.724.724 0 0 1 0 1.449Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M35.5 39a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19Z", fill: theme.vars.palette.secondary.main }),
    /* @__PURE__ */ jsx(
      "rect",
      {
        fill: theme.vars.palette.primary.dark,
        height: "9",
        rx: "1.5",
        transform: "rotate(-180 37 32)",
        width: "3",
        x: "37",
        y: "32"
      }
    ),
    /* @__PURE__ */ jsx("circle", { cx: "35.5", cy: "34.5", fill: theme.vars.palette.primary.dark, r: "1.5", transform: "rotate(-180 35.5 34.5)" })
  ] });
}
PaymentError.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "PaymentError"
};
validateTidalLicense();
export {
  PaymentError
};
//# sourceMappingURL=PaymentError.js.map
